/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_SubmitInputs */

const fr_plan_choice_submit = /** @type {(inputs: Plan_Choice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer vers le paiement`)
};

/**

* @param {Plan_Choice_SubmitInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_submit = /** @type {((inputs?: Plan_Choice_SubmitInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_SubmitInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_submit(inputs)
});